import React from 'react';
  


interface IProps {
  onClick ?: () => void
}
const DotsIcon = ({onClick} :IProps) => {
  return (
    
<svg width="32" height="36" viewBox="0 0 32 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="path-1-inside-1_2017_1650" fill="white">
<path d="M0 0H32V36H0V0Z"/>
</mask>
<path d="M0 0H32V36H0V0Z" fill="#F0F1F5"/>
<path d="M0 1H32V-1H0V1ZM32 35H0V37H32V35Z" fill="#C4C4C4" mask="url(#path-1-inside-1_2017_1650)"/>
<rect x="12" y="17" width="2" height="2" rx="0.3" fill="black"/>
<rect x="15" y="17" width="2" height="2" rx="0.3" fill="black"/>
<rect x="18" y="17" width="2" height="2" rx="0.3" fill="black"/>
</svg>

  );
};

export default DotsIcon;